import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MediaCategoryNamesPopupComponent } from './media-category-names-popup/media-category-names-popup.component';
import { MediaCategoryPopupComponent } from './media-category-popup/media-category-popup.component';
import { MediaCategoryComponent } from './media-category/media-category.component';
import { SafeHtmlPipe, SaleAdminNotificationSettingPopupComponent } from './sale-admin-notification-setting-popup/sale-admin-notification-setting-popup.component';
import { SaleTemplateCategoriesPopupComponent } from './sale-template-categories-popup/sale-template-categories-popup.component';
import { ViewerTemplateCategoriesPopupComponent } from './viewer-template-categories-popup/viewer-template-categories-popup.component';
import { SaleTemplateComponent } from './sale-template/sale-template.component';
import { SettingsComponent } from './settings/settings.component';
import { VetSettingsComponent } from './vet-settings/vet-settings.component';
import { VetUserNotificationSettingComponent } from './vet-user-notification-setting/vet-user-notification-setting.component';
import { NotificationTypePopupComponent } from './notification-type-popup/notification-type-popup.component';
import { MatRadioModule } from '@angular/material/radio';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NotificationTypeListComponent } from './notification-type/notification-type-list/notification-type-list.component';
import { NotificationTypeEditComponent } from './notification-type/notification-type-edit/notification-type-edit.component';
import { SearchBoxModule } from '../shared/search-box/search-box.module';

@NgModule({
  declarations: [
    MediaCategoryComponent,
    MediaCategoryNamesPopupComponent,
    SettingsComponent,
    SaleTemplateComponent,
    SaleTemplateCategoriesPopupComponent,
    SaleAdminNotificationSettingPopupComponent,
    VetUserNotificationSettingComponent,
    MediaCategoryPopupComponent,
    VetSettingsComponent,
    ViewerTemplateCategoriesPopupComponent,
    NotificationTypePopupComponent,
    SafeHtmlPipe,
    NotificationTypeListComponent,
    NotificationTypeEditComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    NgbModule,
    NgbDropdownModule,
    InfiniteScrollModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatFormFieldModule,
    DragDropModule,
    CdkTableModule,
    CdkTreeModule,
    ScrollingModule,
    NgxIntlTelInputModule,
    SearchBoxModule
  ],
  exports: [VetUserNotificationSettingComponent, SaleAdminNotificationSettingPopupComponent]
})
export class SettingsModule {}
